import React from "react";
import { ForgotPasswordForm } from "@/components/auth/ForgotPasswordForm";

export function ForgotPassword() {
  return <ForgotPasswordForm />;
}
